import React, { Component } from 'react';

class InventoryPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmationChecked: false,
            emailPopupOpen: false,
            emailInput: '',
        };
    }

    handleConfirmationChange = (event) => {
        this.setState({ confirmationChecked: event.target.checked });
    };

    handleEmailButtonClick = () => {
        this.setState({ emailPopupOpen: true });
    };

    handleEmailInput = (event) => {
        this.setState({ emailInput: event.target.value });
    };

    handleSendEmail = () => {
        // Implement your logic for sending the email here
        console.log('Sending email to:', this.state.emailInput);
        // Close the email popup
        this.setState({ emailPopupOpen: false });
    };

    render() {
        const { confirmationChecked, emailPopupOpen, emailInput } = this.state;

        return (
            <div className="return-form">
                <h1>Return Form</h1>
                <p>You can fill out your return directly on your tablet/smartphone.</p>
                
                <button className="pdf-button">Return Slip (PDF)</button>
                <p>Print out the return slip in advance and note down any remaining goods in your markets warehouse.</p>

                <button className="email-button" onClick={this.handleEmailButtonClick}>Send via Email</button>
                <p>If you have a clean printer, you have the option to send this return slip via email to print it externally.</p>

                <input
                    type="checkbox"
                    id="confirmation"
                    name="confirmation"
                    checked={confirmationChecked}
                    onChange={this.handleConfirmationChange}
                />
                <label htmlFor="confirmation">
                    I confirm that I have filled out the return slip in writing or want to fill it online with a tablet/smartphone.
                </label>

                <button
                    className="submit-button"
                    disabled={!confirmationChecked}
                >
                    Submit Return Data
                </button>

                {emailPopupOpen && (
                    <div className="email-popup">
                        <input
                            type="text"
                            placeholder="Enter email address"
                            value={emailInput}
                            onChange={this.handleEmailInput}
                        />
                        <button onClick={this.handleSendEmail}>Send Email</button>
                    </div>
                )}
            </div>
        );
    }
}

export default InventoryPage;


// WEBPACK FOOTER //
// ./src/pages/returnCheckout/InventoryPage.js